export default __webpack_public_path__ + "static/5-ce1906440ba729979a563603cb69ffcc.jpg";